import * as React from 'react';
import Button from '@material-ui/core/Button';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

function Premium({profile} :any) {
  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
       <p><strong>Manage your Subscription Plan</strong></p>
      <Button
        href={ profile.subscription?.billing_portal_url }
        size="small"
        variant="outlined"
        startIcon={<AccountBalanceIcon />}
      >
        Update or cancel subscription
      </Button>
      </p>
    </div>
  );
}

export default Premium;
